import { HBBTV_CONST } from '../constants/constants';

const checkStoreType = () => {
    if ('localStorage' in window && window['localStorage'] !== null)
        return HBBTV_CONST.STORE_TYPE_LOCAL_STORAGE;
    if (window.document.cookie)
        return HBBTV_CONST.STORE_TYPE_COOKIES;
    localStoragePolyfill();
    return HBBTV_CONST.STORE_TYPE_UNKNOW;
};

const localStoragePolyfill = () => {
    const store = {
        setItem: (id, val) => {
            return store[id] = String(val);
        },
        getItem: (id) => {
            return store.hasOwnProperty(id) ? String(store[id]) : undef;
        },
        removeItem: (id) => {
            return delete store[id];
        }
    };
    window.localStorage = store;
}

export default class StorageManager {
    static instance;

    constructor() {
        if (this.instance) {
            return this.instance;
        }
        this.instance = this;
        this.storageMode = checkStoreType();
    }

    getStorageType = () => {
        return this.storageMode;
    }

    setItem = (key, value) => {
        switch (this.storageMode) {
            case HBBTV_CONST.STORE_TYPE_COOKIES:
                window.document.cookie = `${key} = ${value} ; expires=Thu, 31 Dec 2090 12:00:00 UTC`;
                break;
            case HBBTV_CONST.STORE_TYPE_LOCAL_STORAGE:
            case HBBTV_CONST.STORE_TYPE_UNKNOW:
                window.localStorage.setItem(key, value);
                break;
        }
    }

    getItem = (key) => {
        switch (this.storageMode) {
            case HBBTV_CONST.STORE_TYPE_COOKIES:
                const name = key.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
                var regex = new RegExp('(?:^|;)\\s?' + name + '=(.*?)(?:;|$)', 'i'),
                    match = document.cookie.match(regex);
                return (match && unescape(match[1]));
            case HBBTV_CONST.STORE_TYPE_LOCAL_STORAGE:
            case HBBTV_CONST.STORE_TYPE_UNKNOW:
                return window.localStorage.getItem(key);
        }
    }

    removeItems = (items) => {
        if (!Array.isArray(items))
            return;
        items.forEach(item => {
            switch (this.storageMode) {
                case HBBTV_CONST.STORE_TYPE_COOKIES:
                    window.document.cookie = `${item}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
                    break;
                case HBBTV_CONST.STORE_TYPE_LOCAL_STORAGE:
                case HBBTV_CONST.STORE_TYPE_UNKNOW:
                    window.localStorage.removeItem(item);
                    break;
            }
        });
    };
}